export const preparePositionString = (string) =>
  typeof string === 'string' ? string.replace(/_/g, ' ') : null;
